/********************************************
 * Timeline Carousel
*
* Flickity carousel
* https://flickity.metafizzy.co/
********************************************/
function fnTimelineCarousel( i, oSection ) {

	/*****************
	* Objects
	*****************/
	var oSection				= $( oSection ),
		oCarousel				= $( '.carousel', oSection ),
		oArrows					= $( '.nav-arrows', oSection ),
		iCurrentSlide;


	/*****************
	* Carousel configuration
	*****************/

	/**
	* Initialise Flickity
	*/
	var $oFlickity				= oCarousel.flickity({
		cellAlign: 					'left',
		freeScroll: 				true,
		freeScrollFriction: 		0.075,
		contain: 					true,
		accessibility: 				false,
		prevNextButtons: 			false,
		pageDots: 					false
	});

	/**
	* Store carousel data
	*/
	var aCarouselData			= $oFlickity.data( 'flickity' ),
		iTotalSlides			= aCarouselData.slides.length;

	/**
	* Arrow buttons (prev/next)
	*/
	oArrows.find( '.next' ).on( 'click', function() {
		$oFlickity.flickity( 'next' );
	});
	oArrows.find( '.previous' ).on( 'click', function() {
		$oFlickity.flickity( 'previous' );
	});


}


// END OF DOCUMENT
